import Vue from 'vue';
import VueRouter from 'vue-router';
import Settings from '../views/settings.vue';
import Guide from '../views/guide.vue';
import Styleguide from '../views/styleguide.vue';
import Admin from '../views/admin.vue';
import Homepage from '../views/homepage.vue';

import store from '@/store/index.js';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'Home',
		meta: {
			layout: 'blank'
		},
		component: Homepage
	},
	{
		path: '/settings',
		name: 'Settings',
		component: Settings
	},
	{
		path: '/guide',
		name: 'Guide',
		component: Guide
	},
	{
		path: '/styleguide',
		name: 'Styleguide',
		component: Styleguide
	},
	{
		path: '/admin',
		name: 'Admin',
		component: Admin
	}
	// {
	//   path: '/about',
	//   name: 'About',
	//   // route level code-splitting
	//   // this generates a separate chunk (about.[hash].js) for this route
	//   // which is lazy-loaded when the route is visited.
	//   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
	// }
];

const router = new VueRouter({
	routes
});

router.beforeEach((to, from, next) => {
	if (store.state.init) {
		store.dispatch('event/trackEvent', {
			name: `Page navigation`,
			data: {
				name: to.name,
				route: to.path
			}
		});
		store.dispatch('ui/setLoaderState', true);
		setTimeout(() => {
			store.dispatch('ui/setLoaderState', false);
		}, 50);
	}
	next();
});

router.afterEach((to, from) => {});

export default router;
